var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-4 rich-text-block-wrapper"},[(_vm.parentFeature || _vm.parentlessCommentsEnabled || _vm.addAddressManually)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.config.defaultContent)}}):_c('b-spinner',{attrs:{"small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }